import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-207a7fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "row mb-4 g-4" }
const _hoisted_3 = { class: "stat-card-inner" }
const _hoisted_4 = { class: "stat-icon-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "stat-trend"
}
const _hoisted_6 = { class: "stat-content" }
const _hoisted_7 = { class: "stat-label" }
const _hoisted_8 = { class: "stat-number" }
const _hoisted_9 = { class: "stat-description" }
const _hoisted_10 = { class: "modern-card" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header-modern\" data-v-207a7fa2><div class=\"d-flex align-items-center justify-content-between\" data-v-207a7fa2><div data-v-207a7fa2><h4 class=\"card-title\" data-v-207a7fa2><i class=\"bi bi-clock-history me-2\" data-v-207a7fa2></i> Historique des actions </h4><p class=\"card-subtitle\" data-v-207a7fa2>Toutes les actions de modération des 30 derniers jours</p></div></div></div>", 1)
const _hoisted_12 = { class: "card-body p-0" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "modern-table" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar3 me-2" }),
      /*#__PURE__*/_createTextVNode(" Date & Heure ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person me-2" }),
      /*#__PURE__*/_createTextVNode(" Talent concerné ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightning me-2" }),
      /*#__PURE__*/_createTextVNode(" Action effectuée ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear me-2" }),
      /*#__PURE__*/_createTextVNode(" Type d'action ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-2" }),
      /*#__PURE__*/_createTextVNode(" Détails ")
    ])
  ])
], -1))
const _hoisted_16 = { class: "date-wrapper" }
const _hoisted_17 = { class: "date-main" }
const _hoisted_18 = { class: "date-time" }
const _hoisted_19 = { class: "talent-wrapper" }
const _hoisted_20 = { class: "talent-avatar" }
const _hoisted_21 = { class: "talent-info" }
const _hoisted_22 = { class: "talent-name" }
const _hoisted_23 = { class: "details-wrapper" }
const _hoisted_24 = { class: "details-text" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "empty-state"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "empty-state-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-inbox" })
    ]),
    /*#__PURE__*/_createElementVNode("h5", { class: "empty-title" }, "Aucune action récente"),
    /*#__PURE__*/_createElementVNode("p", { class: "empty-text" }, "Les actions de modération apparaîtront ici")
  ])
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "card-footer-modern" }
const _hoisted_29 = { class: "footer-info" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsCards, (value, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-md-3",
          key: key
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["stat-card", value.cardClass])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["stat-icon", value.iconClass])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(value.icon)
                  }, null, 2)
                ], 2),
                (value.trend)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("i", {
                        class: _normalizeClass(value.trendIcon)
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(value.label), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(value.count), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(value.description), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["stat-card-footer", value.footerClass])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([value.footerIcon, "me-2"])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(value.footerText), 1)
            ], 2)
          ], 2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionsRecentes, (action) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: action.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDateMain(action.dateAction)), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatTime(action.dateAction)), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.getInitials(action.talent)), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(action.talent.nom) + " " + _toDisplayString(action.talent.prenom), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["action-badge", _ctx.getBadgeClass(action.action)])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.getActionIcon(action.action), "me-1"])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.getActionLabel(action.action)), 1)
                    ], 2)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["type-badge", action.estAutomatique ? 'type-auto' : 'type-manual'])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([action.estAutomatique ? 'bi bi-robot' : 'bi bi-person-gear', "me-1"])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(action.estAutomatique ? 'Automatique' : 'Manuel'), 1)
                    ], 2)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getDetailsWithAdmin(action)), 1)
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.actionsRecentes.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_27))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createTextVNode(" Affichage des " + _toDisplayString(_ctx.actionsRecentes.length) + " dernières actions ", 1)
        ])
      ])
    ])
  ]))
}